import clsx from 'clsx'
import { Jumbotron as JumbotronData } from '@/payload-types'
import { JumbotronStyle } from './jumbotron'

export const JumbotronContent = ({
  jumbotron,
  jumbotronStyle,
}: {
  jumbotron: JumbotronData | undefined
  jumbotronStyle: JumbotronStyle
}) => (
  <>
    <div className={`pt-12 md:pt-32 px-4 mx-auto max-w-jumbotronWidth text-center`}>
      <div>
        <div>
          <h1
            className={clsx(
              `md:mb-6 md:text-[45px] text-[30px] leading-[50px] tracking-tight font-extrabold text-${jumbotronStyle?.title?.color}`,
            )}
          >
            {jumbotron?.text.title}
          </h1>
          <p
            className={clsx(
              `mb-8 text-lg font-semibold lg:text-xl sm:px-16 lg:px-8 font-sans text-${jumbotronStyle?.subTitle?.color}`,
            )}
          >
            {jumbotron?.text.subtitle}{' '}
          </p>
        </div>
      </div>
    </div>
  </>
)
